module.exports = __webpack_public_path__ + "img/756.1f8994fb.png";